const translation = {
  title: '推理服务',
  deployment: '部署模型推理服务',
  modelName: '选择模型',
  serviceName: '服务名称',
  deploymentName: '选择部署',
  createDeployment: '创建推理服务',
  searchPlaceholder: '搜索',
  list: {
    empty_text: '暂无数据',
  },
  newDeployment: {
    startToCreate: '创建一个新的模型推理服务',
  },
  gpu_num: 'GPU数量',
  // DeploymentList 组件词条
  idAndName: '名称 / ID',
  status: '状态',
  permission: '权限',
  model: '模型',
  image: '镜像',
  resourceInfo: '资源信息',
  replicas: '副本',
  createUpdateTime: '创建/更新时间',
  createdAt: '创建时间',
  updatedAt: '更新时间',
  accessEntry: '访问入口',
  accessService: '访问服务',
  setModel: '设置模型',
  password: '密码：******',
  operations: '操作',
  stop: '停止',
  start: '启动',
  logs: '日志',
  inferenceLog: '推理日志：',
  editService: '编辑服务',
  delete: '删除',
  deleteService: '删除服务',
  more: '更多',
  providerNotFound: 'Provider not found!',
  // DeploymentDetail 组件词条
  deploymentDetail: {
    title: '推理服务详情',
    tab: {
      detail: '详情',
      log: '日志',
      event: '事件',
      monitor: '监控',
      pod: '容器',
    },
  },

  // DeploymentForm 组件词条
  form: {
    serviceName: '服务名称',
    serviceNameTooltip: '推理服务的唯一标识名称，支持英文字母、数字和短横线，创建后不可修改',
    serviceType: '服务类型',
    serviceTypeTooltip: '无状态服务适用于大多数推理场景；有状态服务适用于需要持久化存储的场景',
    stateless: '无状态',
    stateful: '有状态',
    deploymentPermission: '部署权限',
    deploymentPermissionTooltip: '设置推理服务的访问权限：私有仅自己可见，公开则项目内所有成员可见',
    deploymentResource: '部署资源',
    deploymentResourceTooltip: '选择推理服务运行所需的计算资源，包括GPU型号、数量和实例规格',
    storageMount: '存储挂载',
    storageMountTooltip: '将存储磁盘、模型或数据集挂载到容器指定路径，用于数据读取和持久化存储',
    deploymentModel: '部署模型',
    deploymentModelTooltip: '选择要部署的模型，模型将被挂载到容器中供推理服务加载使用',
    modelVersion: '模型版本',
    modelVersionTooltip: '选择要部署的模型版本，不同版本可能对应不同的训练结果或参数配置',
    inferenceImage: '设置镜像',
    inferenceImageTooltip: '选择推理服务运行的容器镜像，镜像中应包含推理框架和所需依赖环境',
    workingDirectory: '工作目录',
    workingDirectoryTooltip: '容器启动时的工作目录路径，启动命令将在此目录下执行',
    startupCommand: '启动命令',
    startupCommandTooltip:
      '系统环境变量，通过"{{变量名称}}"方式进行引用：model_id: 模型ID，model_name: 模型名称，model_version: 模型版本，model_path: 模型路径，deployment_id: 部署ID，deployment_name: 部署名称，service_name: 服务名称，api_key: API密钥',
    startupArgs: '启动参数',
    startupArgsTooltip: '自定义启动参数，可以在启动变量中进行引用',
    environmentVariables: '环境变量',
    environmentVariablesTooltip: '设置容器运行时的环境变量，可用于配置推理服务的运行参数和行为',
    expirationTime: '到期时间',
    expirationTimeTooltip: '服务到期后将自动停止并释放资源，不设置则长期运行',
    selectExpirationTime: '选择到期时间',
    serviceTraffic: '服务流量',
    serviceTrafficTooltip: '服务流量是否只能由master节点接收',
    allNodes: '所有节点',
    masterNode: 'Master节点',
    ipWhitelist: 'IP白名单',
    ipWhitelistTooltip: '限制只有白名单中的IP地址可以访问该推理服务，不设置则允许所有IP访问',
    ipWhitelistPlaceholder: '支持多个IP，以逗号分隔',
    hpa: '自动实例扩缩',
    hpaTooltip: '根据推理服务所有实例的平均CPU/GPU利用率指标进行自动扩缩容',
    submit: '提交',
    cancel: '取消',
    update: '更新',
    create: '创建',
    updateInferenceService: '更新推理服务',
    createInferenceService: '创建推理服务',
    totalCost: '总费用',
    perHour: '/小时',
  },

  // 编辑页面
  editPage: {
    title: '推理服务详情',
  },

  // WorkloadPodList 组件词条
  podList: {
    name: '名称',
    status: '状态',
    node: '节点',
    ip: 'IP',
    startTime: '开始时间',
    operations: '操作',
    viewLogs: '查看日志',
    viewEvents: '查看事件',
    loginContainer: '登录容器',
  },
}

export default translation
